module.exports = __webpack_public_path__ + "static/img/syfw-1.9e208f04.jpg";